import { Routes } from '@angular/router';
import { FleetPageComponent } from './fleet-page.component';

export const FleetRouteName = {
  Main: 'fleet',
};

export const FLEET_ROUTES: Routes = [
  {
    path: '',
    component: FleetPageComponent,
  },
];
